import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { addWalletBalanceToEmployee, employeeList, employeeLocationReportId, getEmployeePayroleList } from "../../Services/Operations/ProductAPI";
import { Section } from "../../Core/Section";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { baseURL } from "../../Services/api_endpoints";

const Employee = () => {
  const [employee, setEmployee] = useState([]);
  const [allPayrollList,setAllPayrollList]=useState([])
  const [empId,setEmpId]=useState(null)
  const [modalOpen,setModalOpen]=useState(false)
  const [payrollList,setPayrollList]=useState([])
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const[selectedEmp,setSelectedEmp]=useState(null)
  const[showModal,setShowModal]=useState(false)
  const [showAmountModal, setShowAmountModal] = useState("");
const [amount, setAmount] = useState("");

        const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 10;
      
      const indexOfLast = currentPage * itemsPerPage;
      const indexOfFirst = indexOfLast - itemsPerPage;
      
      const currentUsers = employee.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    const fetchEmployeeList = async () => {
      try {
        const response = await employeeList(token);
        setEmployee(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchEmployeeList();
    handleGetPauroleList()
  }, []);

  const handleAddRole = (id) => {
    console.log("Id : ", id);
    navigate("/employee-allocation", { state: { EmployeeSelectId: id } });
  };

  const handleAddPayRole = () => {
    navigate("/employee-payroll");
  };

  const handleGetPauroleList=async()=>{
    try {
      const response=await getEmployeePayroleList(token)
      console.log("payrole list : ",response);
      if(response.data.status==='success'){
        setAllPayrollList(response.data.data)
      }
      
    } catch (error) {
      console.log("error : ",error);
      
    }
  }

  const handlemodalOpen=(id)=>{
    setEmpId(id)
  
      setModalOpen(true)
   
    
    const filterPayroll=allPayrollList.filter((item)=>item.employeeId===id)
    setPayrollList(filterPayroll)
  }

  const handleViewDetails=(employee)=>{
    setSelectedEmp(employee)
    setShowModal(true)
  }
  const handleCloseModal=()=>{
    setShowModal(false)
    setSelectedEmp(null)
  }

  const handleEmpLocationById=async(id)=>{
    let data={
      token,
      id
    }
    try {
      const response=await employeeLocationReportId(data)
      console.log('employeeLocationReportId',response);
      
    } catch (error) {
      console.log(error);
      
    }
  }

    const handleEmpWalletAdd=async(id)=>{
   
    try {
      const response=await addWalletBalanceToEmployee( token,
      id,
      5000)
      console.log('employeeLocationReportId',response);
      
    } catch (error) {
      console.log(error);
      
    }
  }

  return (
     <div id="main_content">
        <Header />
        <div className="page">
          <Section />
          <div className="section-body">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center ">
                <div className="header-action">
                  <h1 className="page-title">Employees</h1>
                  <ol className="breadcrumb page-breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">RNDSAN</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Employees
                    </li>
                  </ol>
                </div>
              </div>
              <button
                      onClick={() => handleAddPayRole()}
                      className="btn btn-primary"
                      style={{float:"right"}}
                    >
                      Pay Roll
                    </button>
            </div>
          </div>
  
          <div className="section-body mt-4">
            <div className="container-fluid">
              <div className="tab-content">
                 
                <div className="tab-pane active" id="Dep-all">
                  <div className="table-responsive">
                    <div className="table-responsive card">
                      <table className="table table-hover js-basic-example dataTable table-striped table_custom border-style spacing5">
                        <thead>
                          <tr>
                            <th style={{textAlign:"center"}}>ID</th>
                         
                            <th style={{textAlign:"center"}}>Name</th>
                            <th style={{textAlign:"center"}}>Gender</th>
                            <th style={{textAlign:"center"}}>Number</th>
                            <th style={{textAlign:"center"}}>Profession</th>
                            <th style={{textAlign:"center"}}>Specialization</th>
                           <th style={{textAlign:"center"}}>Action</th>
                            <th style={{textAlign:"center"}}>Role</th>
                            <th style={{textAlign:"center"}}>State</th>
                            <th style={{textAlign:"center"}}>Wallet</th>
                              <th style={{textAlign:"center"}}>Location</th>
                            <th style={{textAlign:"center"}}>History</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentUsers.map((employee,index) => (
                            <tr key={employee.id}>
                              <td>{indexOfFirst+index+1}</td>
                            
                              <td>
                                {employee.firstName} {employee.middleName}{" "}
                                {employee.lastName}
                              </td>
                              <td>{employee.gender}</td>
                              <td>{employee.primaryNumber}</td>
                              <td>{employee.profession}</td>
                              <td>{employee.specialization}</td>
                              <td>
                                 <button
                                type="button"
                                className="btn btn-icon btn-sm"
                                title="View"
                                onClick={() => handleViewDetails(employee)}
                              >
                                <i className="fa fa-eye" />
                              </button>
                              </td>
                      
                              <td>
                                <button
                                  onClick={() => handleAddRole(employee.id)}
                                  className="btn btn-primary"
                                >
                                  Add
                                </button>
                              </td>
                              <td>{employee.state}</td>
                              <td>
                               <button style={{padding:"8px",borderRadius:"8px",backgroundColor:"#250606"}}
                              onClick={()=>setShowAmountModal(employee.id)}
                              >Add</button> 
                              </td>
  
                              
                              <td><button style={{padding:"8px",borderRadius:"8px",backgroundColor:"#250606"}}
                              onClick={()=>handleEmpLocationById(employee.id)}
                              >Report</button></td>
                              <td>
                                <button
                                  type="button"
                                  className="btn "
                                  style={{ backgroundColor: "#0051ffff", color: "white",fontSize:"12px" }}
                                  onClick={() => handlemodalOpen(employee.id)}
                                >
                                 Pay Roll History
                                </button>
                               
                              
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
  
                                        <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                               <button
      disabled={currentPage === 1}
      onClick={() => setCurrentPage((prev) => prev - 1)}
      className="btn btn-primary btn-sm me-2"
    >
      Prev
                       </button>
  
                        <span> Page {currentPage} of {Math.ceil(employee.length / itemsPerPage)} </span>
  
                    <button
      disabled={currentPage === Math.ceil(employee.length / itemsPerPage)}
      onClick={() => setCurrentPage((prev) => prev + 1)}
      className="btn btn-primary btn-sm ms-2"
    >
      Next
                 </button>
  </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div className="section-body">
            <footer className="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    Copyright © 2025{" "}
                    <a href="">Technology support By - Siance Software Pvt Ltd</a>
                    .
                  </div>
                </div>
              </div>
            </footer>
          </div>
  
          {/* ================= MODAL 1 : ENTER AMOUNT (wallet) ================= */}
          {showAmountModal && (
            <div className="em-overlay">
              <div className="em-dialog em-dialog-sm">
                <div className="em-head">
                  <span className="em-head-icon">
                    <i className="fa fa-credit-card" />
                  </span>
                  <div className="em-head-text">
                    <h3 className="em-title">Enter Amount</h3>
                    <p className="em-sub">Add money to wallet · Employee ID {showAmountModal}</p>
                  </div>
                  <button
                    type="button"
                    className="em-close"
                    aria-label="Close"
                    onClick={() => setShowAmountModal(false)}
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>
  
                <div className="em-body">
                  <label className="em-label">Amount</label>
                  <div className="em-amount">
                    <span className="em-amount-sign">₹</span>
                    <input
                      type="number"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      min="0"
                    />
                  </div>
  
                  <button
                    className="em-btn em-btn-red em-btn-block"
                    onClick={() => {
                      if (amount.trim() === "" || Number(amount) <= 0) {
                        alert("Please enter a valid amount");
                        return;
                      }
                      handleEmpWalletAdd(showAmountModal)
  
                      console.log("Submitted amount:", Number(amount));
                      setShowAmountModal(false);
                    }}
                  >
                    <i className="fa fa-check-circle" /> Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
  
        {/* ================= MODAL 2 : PAYROLL HISTORY ================= */}
        <div>
          {modalOpen && (
            <div className="em-overlay em-overlay-right">
              <div className="em-dialog em-dialog-drawer">
                <div className="em-head">
                  <span className="em-head-icon">
                    <i className="fa fa-file-text-o" />
                  </span>
                  <div className="em-head-text">
                    <h3 className="em-title">Payroll History</h3>
                    <p className="em-sub">Payroll list for Employee id :{empId}</p>
                  </div>
                  <button
                    type="button"
                    className="em-close"
                    aria-label="Close"
                    onClick={()=>setModalOpen(false)}
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>
  
                <div className="em-body em-scroll">
                  {
                    payrollList.length>0?(
                      <div>
                        {
                          payrollList.map((item, i)=>(
                            <div className="em-pay" key={i}>
                              <div className="em-pay-month">
                                <i className="fa fa-calendar" /> {item.recordMonth}
                              </div>
                              <div className="em-pay-grid">
                                <div className="em-pay-cell">
                                  <span>Ctc</span>
                                  <b>{item.ctc}</b>
                                </div>
                                <div className="em-pay-cell">
                                  <span>GrossSalary</span>
                                  <b>{item.grossSalary}</b>
                                </div>
                                <div className="em-pay-cell em-pay-main">
                                  <span>PaymentAmount</span>
                                  <b>{item.paymentAmount}</b>
                                </div>
                                <div className="em-pay-cell">
                                  <span>CasualLeave</span>
                                  <b>{item.casualLeave}</b>
                                </div>
                                <div className="em-pay-cell">
                                  <span>UnpaidLeave</span>
                                  <b>{item.unpaidLeave}</b>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    ):(
                      <div className="em-empty">
                        <i className="fa fa-inbox" />
                        No Payroll record found
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          )}
        </div>
  
        {/* ================= MODAL 3 : EMPLOYEE DETAILS ================= */}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          size="md"
          centered
          dialogClassName="em-rb"
        >
            <Modal.Header closeButton className="em-rb-head">
              <Modal.Title>Employee Details</Modal.Title>
            </Modal.Header>
            <Modal.Body className="em-rb-body">
              {selectedEmp ? (
                <div>
                  <div className="em-profile">
                    <div className="em-avatar">
                      <img
                        src={baseURL+'api'+ selectedEmp?.profileImage}/>
                    </div>
                    <div>
                      <p className="em-profile-name">
                        {selectedEmp.firstName}{"  "}{selectedEmp.lastName}
                      </p>
                      <span className="em-profile-id">ID {selectedEmp.id}</span>
                    </div>
                  </div>
  
                  <div className="em-info">
                    <div className="em-info-row">
                      <i className="fa fa-id-badge" />
                      <div>
                        <span>ID</span>
                        <b>{selectedEmp.id}</b>
                      </div>
                    </div>
                    <div className="em-info-row">
                      <i className="fa fa-user" />
                      <div>
                        <span>Name</span>
                        <b>{selectedEmp.firstName}{"  "}{selectedEmp.lastName}</b>
                      </div>
                    </div>
                    <div className="em-info-row em-info-wide">
                      <i className="fa fa-shield" />
                      <div>
                        <span>Assigned Role</span>
                        <div className="em-roles">
                          {(selectedEmp.roles).map((rol, i)=>(
                            <em key={i}>{rol.id===1?"Senior Marketing Executive":rol.id===2?"Junior Marketing Executive":
                                  rol.id===8?"Regional Manger":  rol.employeeRoleName}</em>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="em-info-row">
                      <i className="fa fa-briefcase" />
                      <div>
                        <span>Profession</span>
                        <b>{selectedEmp.profession}</b>
                      </div>
                    </div>
                    <div className="em-info-row">
                      <i className="fa fa-stethoscope" />
                      <div>
                        <span>Specializations</span>
                        <b>{selectedEmp.specialization}</b>
                      </div>
                    </div>
                    <div className="em-info-row em-info-wide">
                      <i className="fa fa-graduation-cap" />
                      <div>
                        <span>Degree</span>
                        <b>{selectedEmp.degree }</b>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <p>No details available</p>
              )}
            </Modal.Body>
            <Modal.Footer className="em-rb-foot">
              <Button variant="secondary" onClick={handleCloseModal} className="em-btn em-btn-dark">
                Close
              </Button>
            </Modal.Footer>
          </Modal>
      </div>
  );
};
export default Employee;
